import { render, staticRenderFns } from "./NotificationListWidget.vue?vue&type=template&id=1b495a8a&"
import script from "./NotificationListWidget.vue?vue&type=script&lang=js&"
export * from "./NotificationListWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports